import type { Crumb } from "@mdotm/shadcn/mdotm/components";
import { Button } from "@mdotm/shadcn/mdotm/components";
import { useTranslation } from "react-i18next";
import { PageHeader } from "$root/components/PageHeader";
import { qualifier } from "$root/utils";

export type ReviewHeaderProps = {
	crumbs: Crumb[];
	onCancel(): void;
	/** Absent when the user cannot edit the composition; `loading` until the rows arrive, or when they fail to. */
	save?: { kind: "loading" } | { kind: "ready"; onSave(): Promise<unknown> };
};

/** The review page's header: its crumbs, Cancel, and Save when there is one. */
export function ReviewHeader({ crumbs, onCancel, save }: ReviewHeaderProps): React.JSX.Element {
	const { t } = useTranslation();
	return (
		<PageHeader
			crumbs={crumbs}
			titleAction={
				<div className="flex items-center space-x-2">
					<Button
						size="small"
						palette="tertiary"
						onClick={onCancel}
						data-qualifier={qualifier.reviewInstruments.cancel}
					>
						{t("BUTTON.CANCEL")}
					</Button>

					{save && (
						<Button
							size="small"
							palette="primary"
							disabled={save.kind === "loading"}
							onClickAsync={save.kind === "ready" ? save.onSave : undefined}
							data-qualifier={qualifier.reviewInstruments.save}
						>
							{t("BUTTON.SAVE")}
						</Button>
					)}
				</div>
			}
		/>
	);
}
